export const getStatus = (status: string): string => status.replace(/_/g, ' ').replace(/rejected/g, 'declined');
